<div class="home-decision" data-section-id="homeia_home_root" [class.home-decision--attention]="attentionLayoutEnabled">
  <ng-container *ngIf="{ pulse: (pulseState$ | async), overview: (overviewState$ | async), next: (nextBestDecisionState$ | async), list: (decisionListState$ | async), calendar: (calendarDecisionState$ | async), detail: (decisionDetailState$ | async), dates: (datesSummaryState$ | async), activity: (lastActivityState$ | async), history: (activityHistoryState$ | async), metrics: (metricsState$ | async), activeState: (activeStateFilter$ | async), selectedDecisionId: (selectedDecisionId$ | async), connectionState: (connectionState$ | async), actionLoading: (actionLoading$ | async), actionMessage: (actionMessage$ | async), actionError: (actionError$ | async), viewMode: (viewMode$ | async), calendarGranularity: (calendarGranularity$ | async), calendarAnchorDate: (calendarAnchorDate$ | async), knowledge: (knowledgeAttentionState$ | async), recentChanges: (recentChangesState$ | async) } as ctx">
    <div class="home-decision__attention-zone" data-section-id="homeia_home_attention_zone">
    <h2 class="home-decision__zone-title" *ngIf="attentionLayoutEnabled">{{ lang.translate('home.attention.sectionTitle') }}</h2>
    <app-home-decision-pulse-strip
      data-section-id="homeia_home_pulse_strip"
      [pulse]="ctx.pulse?.data ?? null"
      [summary]="getDecisionSummary(ctx.overview, ctx.next)"
      [connectionState]="ctx.connectionState ?? null"
      [loading]="ctx.pulse?.loading ?? true"
      [error]="ctx.pulse?.error ?? null"
    ></app-home-decision-pulse-strip>

    <section class="home-decision__hero" data-section-id="homeia_home_next_best_decision">
      <app-home-next-best-decision
        [nextDecision]="ctx.next?.data ?? null"
        [loading]="ctx.next?.loading ?? true"
        [error]="ctx.next?.error ?? null"
        [selectedDecisionId]="ctx.selectedDecisionId ?? null"
        [actionLoading]="ctx.actionLoading ?? false"
        [actionMessage]="ctx.actionMessage ?? null"
        [actionError]="ctx.actionError ?? null"
        (retryRequest)="refreshNextBestDecision()"
        (selectDecision)="onSelectDecision($event)"
        (executeActionRequest)="onExecuteDecisionAction($event)"
      ></app-home-next-best-decision>
    </section>

    <section class="home-decision__summary" data-section-id="homeia_home_decision_summary">
      <app-home-decision-summary
        [summary]="getDecisionSummary(ctx.overview, ctx.next)"
        [loading]="ctx.overview?.loading ?? true"
        [error]="ctx.overview?.error ?? null"
        [activeState]="ctx.activeState ?? 'all'"
        (stateSelect)="onStateFilterChange($event)"
      ></app-home-decision-summary>
    </section>

    <section class="home-decision__view-mode" data-section-id="homeia_home_view_mode">
      <div class="home-decision__view-mode-toggle" role="group" [attr.aria-label]="lang.translate('home.viewMode.label')">
        <button
          type="button"
          class="home-decision__view-mode-button"
          [class.is-active]="(ctx.viewMode ?? 'current') === 'current'"
          [attr.aria-pressed]="(ctx.viewMode ?? 'current') === 'current'"
          (click)="onHomeViewModeChange('current')"
        >
          {{ lang.translate('home.viewMode.current') }}
        </button>
        <button
          type="button"
          class="home-decision__view-mode-button"
          [class.is-active]="ctx.viewMode === 'calendar'"
          [attr.aria-pressed]="ctx.viewMode === 'calendar'"
          (click)="onHomeViewModeChange('calendar')"
        >
          {{ lang.translate('home.viewMode.calendar') }}
        </button>
      </div>
    </section>

    <div class="home-decision__content" [class.home-decision__content--with-detail]="!!ctx.selectedDecisionId">
      <section class="home-decision__list" data-section-id="homeia_home_decision_list">
        <app-home-decision-list
          *ngIf="(ctx.viewMode ?? 'current') === 'current'; else calendarView"
          [page]="ctx.list?.data ?? null"
          [loading]="ctx.list?.loading ?? true"
          [error]="ctx.list?.error ?? null"
          [activeState]="ctx.activeState ?? 'all'"
          [selectedDecisionId]="ctx.selectedDecisionId ?? null"
          (retryRequest)="refreshDecisionList()"
          (selectDecision)="onSelectDecision($event)"
        ></app-home-decision-list>

        <ng-template #calendarView>
          <app-home-decision-calendar
            [page]="ctx.calendar?.data ?? null"
            [loading]="ctx.calendar?.loading ?? true"
            [error]="ctx.calendar?.error ?? null"
            [selectedDecisionId]="ctx.selectedDecisionId ?? null"
            [granularity]="ctx.calendarGranularity ?? 'month'"
            [anchorDate]="ctx.calendarAnchorDate ?? ''"
            (retryRequest)="refreshDecisionList()"
            (selectDecision)="onSelectDecision($event)"
            (granularityChange)="onCalendarGranularityChange($event)"
            (periodShift)="onCalendarPeriodShift($event)"
            (todayRequest)="onJumpToCalendarToday()"
            (anchorDateChange)="onCalendarAnchorDateChange($event)"
          ></app-home-decision-calendar>
        </ng-template>
      </section>

      <section class="home-decision__detail" *ngIf="ctx.selectedDecisionId" data-section-id="homeia_home_decision_detail">
        <app-home-decision-detail
          [detail]="ctx.detail?.data ?? null"
          [loading]="ctx.detail?.loading ?? true"
          [error]="ctx.detail?.error ?? null"
          [actionLoading]="ctx.actionLoading ?? false"
          [actionMessage]="ctx.actionMessage ?? null"
          [actionError]="ctx.actionError ?? null"
          (retryRequest)="refreshDecisionDetail()"
          (closeRequest)="onCloseDecisionDetail()"
          (executeActionRequest)="onExecuteDecisionAction($event)"
        ></app-home-decision-detail>
      </section>
    </div>

    </div>

    <div class="home-decision__follow-up-zone" data-section-id="homeia_home_follow_up_zone">
    <h2 class="home-decision__zone-title" *ngIf="attentionLayoutEnabled">{{ lang.translate('home.attention.followUpTitle') }}</h2>
    <section class="home-decision__support" data-section-id="homeia_home_support_band">
      <div class="home-decision__support-grid">
        <section class="home-decision__support-card" data-section-id="homeia_home_dates_support">
          <app-home-dates-radar
            [summary]="ctx.dates?.data ?? null"
            [loading]="ctx.dates?.loading ?? true"
            [error]="ctx.dates?.error ?? null"
            [empty]="ctx.dates?.empty ?? false"
            [filterSaving]="false"
            [filterMessageKey]="null"
            [filterError]="null"
            (retryRequest)="refreshDatesSummary()"
            (roleFilterChange)="onDatesRoleFilterChange($event)"
          ></app-home-dates-radar>
        </section>

        <section class="home-decision__support-card" data-section-id="homeia_home_activity_support">
          <app-home-last-activity
            [activity]="ctx.activity?.data ?? null"
            [history]="ctx.history?.data?.items ?? null"
            [loading]="ctx.activity?.loading ?? true"
            [error]="ctx.activity?.error ?? null"
            [empty]="ctx.activity?.empty ?? false"
            [compactLauncher]="true"
            [historyLoading]="ctx.history?.loading ?? false"
            [historyPage]="ctx.history?.data?.page ?? 1"
            [historyTotalPages]="ctx.history?.data?.totalPages ?? 1"
            (retryRequest)="refreshActivity()"
            (historyPageChange)="onActivityHistoryPageChange($event)"
          ></app-home-last-activity>
        </section>

        <section class="home-decision__support-card" data-section-id="homeia_home_metrics_support">
          <app-home-stats
            [metrics]="ctx.metrics?.data ?? null"
            [loading]="ctx.metrics?.loading ?? true"
            [error]="ctx.metrics?.error ?? null"
            [empty]="ctx.metrics?.empty ?? false"
            (retryRequest)="refreshMetrics()"
          ></app-home-stats>
        </section>

        <!-- R6 · Widget "Requiere tu atención": self-gated por knowledge_alerts (no requiere inputs ni gating en Home). -->
        <app-home-alerts-widget data-section-id="homeia_home_alerts_support"></app-home-alerts-widget>

        <section
          class="home-decision__support-card"
          data-section-id="homeia_home_knowledge_expirations_support"
          *ngIf="ctx.knowledge?.data?.featureAvailable"
        >
          <app-home-knowledge-expirations
            [section]="ctx.knowledge?.data?.expirations ?? null"
            [featureAvailable]="ctx.knowledge?.data?.featureAvailable ?? false"
            [loading]="ctx.knowledge?.loading ?? true"
            [error]="ctx.knowledge?.error ?? null"
            (retryRequest)="refreshKnowledgeAttention()"
          ></app-home-knowledge-expirations>
        </section>

        <section
          class="home-decision__support-card"
          data-section-id="homeia_home_knowledge_entities_support"
          *ngIf="ctx.knowledge?.data?.featureAvailable"
        >
          <app-home-knowledge-entities
            [section]="ctx.knowledge?.data?.recentEntities ?? null"
            [featureAvailable]="ctx.knowledge?.data?.featureAvailable ?? false"
            [loading]="ctx.knowledge?.loading ?? true"
            [error]="ctx.knowledge?.error ?? null"
            (retryRequest)="refreshKnowledgeAttention()"
          ></app-home-knowledge-entities>
        </section>

        <!-- R5 - Radar de cambios recientes (ADR-R5-04): read-only, bajo el fold. Self-gated por change_detection (404 => featureAvailable=false => oculto, sin request de datos). -->
        <section
          class="home-decision__support-card"
          data-section-id="homeia_home_recent_changes_support"
          *ngIf="ctx.recentChanges?.data?.featureAvailable"
        >
          <app-home-recent-changes-widget
            [response]="ctx.recentChanges?.data ?? null"
            [loading]="ctx.recentChanges?.loading ?? true"
            [error]="ctx.recentChanges?.error ?? null"
            (retryRequest)="refreshRecentChanges()"
          ></app-home-recent-changes-widget>
        </section>
      </div>
    </section>
    </div>
  </ng-container>
</div>
